import Components from "../components";

// The ChannelNotifications component tries to prevent you from adding an "Error filter"
// for events that have been disabled. For example, if you go to "Error Events"
// and uncheck "When an error is assigned to me", this component disables the
// "When an error is assigned to me" option in the "Error filter" select boxes. If you check
// the checkbox, it re-enables the select options.

class ChannelNotifications extends Components.Base {
  initialize() {
    // Important: Any inputs disabled by JavaScript must be re-enabled before
    // the form is submitted to maintain parity of filter values.
    $('form#edit_channel').on('submit', () =>
      this.$el.find('.filter-group option').removeAttr('disabled'),
    );

    this.$el
      .find('input[type=checkbox]')
      .each((i, target) => this.toggleFilters(target));
  }

  bind() {
    this.on('change', 'input[type=checkbox]', e =>
      this.toggleFilters(e.currentTarget),
    );
  }

  toggleFilters(target) {
    const $target = $(target);
    const channelEvent = $target.val();
    const $options = this.$el.find(
      `.filter-group option[value="${channelEvent.replace(/\W/g, '_')}"]`,
    );
    $options.attr(
      'disabled',
      $target.is(':disabled') || !$target.is(':checked'),
    );
  }
}

Components.collection.register({
  selector: '.c-channel-notifications',
  klass: ChannelNotifications,
});
